import {create} from "zustand";
import {EntityType, NeighbourhoodSnapshot, NeighbourhoodSnapshotForm} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {officeArrayResource} from "./CurrentOfficeStore";
import {SeatingPlans_Read} from "../util/access/Permission";

interface NeighbourhoodSnapshotStore extends EntityStore<NeighbourhoodSnapshot[]> {
    createSnapshot: (form: NeighbourhoodSnapshotForm) => Promise<NeighbourhoodSnapshot>;
    updateSnapshot: (snapshot: NeighbourhoodSnapshot, form: NeighbourhoodSnapshotForm) => Promise<NeighbourhoodSnapshot>;
    deleteSnapshot: (snapshot: NeighbourhoodSnapshot) => Promise<void>;
}

export const useNeighbourhoodSnapshotStore = create<NeighbourhoodSnapshotStore>()(
    officeArrayResource<NeighbourhoodSnapshot, NeighbourhoodSnapshotStore>(EntityType.NeighbourhoodSnapshots, builder => {
        const rest = builder.crud<NeighbourhoodSnapshotForm>('/neighbourhood-snapshots', 'id');
        return {
            remoteValue: builder.all(SeatingPlans_Read, () => rest.getAll()),
            createSnapshot: builder.createAndPatch(rest),
            updateSnapshot: builder.updateAndPatch(rest),
            deleteSnapshot: builder.deleteAndPatch(rest),
        };
    })
);

startEntityStore(useNeighbourhoodSnapshotStore);
